import { stopReportingRuntimeErrors } from 'react-error-overlay';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { appConfig } from '../../config';

class ReportingService {
  init() {
    if (appConfig.isLocal) {
      try {
        stopReportingRuntimeErrors(); // disables error overlays
      } catch (e) {
        console.error('failed to stop reporting runtime errors')
      }

    }
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.7,
    });
  }
}

export const reportingService = new ReportingService();
